/**
 * Search State Manager - manages pause/resume for two-pass search
 */

"use strict";

import { debugMode } from './constants.js';

/**
 * Search state for pause/resume functionality
 */
class SearchStateManager {
    constructor() {
        this.reset();
    }

    reset() {
        this.highPriorityResults = []; // HIGH PRIORITY results (boost 5)
        this.highPriorityFoundKeys = new Set(); // Keys of files found by HIGH PRIORITY
        this.lowPriorityResults = []; // LOW PRIORITY results (lower boost)
        this.lowPriorityProcessedIndex = 0; // Index in files array where LOW PRIORITY search paused
        this.isHighPriorityComplete = false; // Whether HIGH PRIORITY pass is complete
        this.isLowPriorityComplete = false; // Whether LOW PRIORITY pass is complete
        this.currentQuery = null; // Current search query
        this.filesArray = null; // Reference to files array being searched
    }

    /**
     * Initialize search state for a new query
     */
    startSearch(query, filesArray) {
        // Reset if query changed OR if filesArray changed (filters applied)
        const queryChanged = this.currentQuery !== query;
        const filesChanged = this.filesArray !== filesArray && filesArray && this.filesArray && 
                            (filesArray.length !== this.filesArray.length || 
                             (filesArray.length > 0 && this.filesArray.length > 0 && filesArray[0] !== this.filesArray[0]));
        
        if (queryChanged || filesChanged) {
            this.reset();
            this.currentQuery = query;
            this.filesArray = filesArray;
            if (debugMode === '1') {
                console.log('[SearchState] Starting new search:', { query, filesCount: filesArray ? filesArray.length : 0, reason: queryChanged ? 'query changed' : 'files changed' });
            }
        }
    }

    /**
     * Check if search can be paused (reached result limit)
     */
    canPause(resultLimit = 50) {
        const totalResults = this.highPriorityResults.length + this.lowPriorityResults.length;
        return totalResults >= resultLimit;
    }

    /**
     * Get current results (HIGH PRIORITY first, then LOW PRIORITY)
     */
    getCurrentResults() {
        return [...this.highPriorityResults, ...this.lowPriorityResults];
    }

    /**
     * Check if search is complete
     */
    isComplete() {
        return this.isHighPriorityComplete && this.isLowPriorityComplete;
    }
}

// Singleton instance
export const searchStateManager = new SearchStateManager();

// Global access
if (typeof window !== 'undefined') {
    window.searchStateManager = searchStateManager;
}

